var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonIconFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.435.005L15.295 0c-3.53 0-5.81 2.415-5.81 6.153v2.836H6.327a.502.502 0 00-.494.51v4.11c0 .282.222.51.494.51h3.158V24.49c0 .282.221.51.494.51h4.12a.502.502 0 00.494-.51V14.12h3.693a.502.502 0 00.494-.51l.001-4.11a.519.519 0 00-.144-.361.486.486 0 00-.35-.15h-3.694V6.585c0-1.156.267-1.743 1.726-1.743h2.116a.502.502 0 00.494-.51V.514a.503.503 0 00-.494-.51z"
  })));
}

export default SvgCommonIconFacebook;